<div class="app-container full-screen">
  <!-- NOTE: Implemented an independent, self-styled loader to ensure it renders immediately without waiting for module component/styles to load. -->
  @if (isLoading) {
    <div class="loading-overlay full-screen d-flex justify-content-center align-items-center">
      <div class="loader"></div>
    </div> 
  }
  <router-outlet></router-outlet>
</div>
